import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

function LoadingScreen() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '12px',
        color: '#5C5C72',
        fontSize: '14px',
      }}
    >
      <div
        style={{
          width: 28,
          height: 28,
          border: '2px solid #E2E0DB',
          borderTopColor: '#1B4A8C',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      잠시만 기다려 주세요
    </div>
  );
}

// ① 로그인 필수
export function RequireAuth() {
  const { user, authLoading } = useAuth();
  const location = useLocation();

  if (authLoading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  return <Outlet />;
}

// ② 유효한 수강생 또는 관리자 필수
export function RequireStudent() {
  const { user, isAdmin, studentStatus, authLoading } = useAuth();

  if (authLoading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (isAdmin) return <Outlet />;
  if (studentStatus === 'loading') return <LoadingScreen />;

  // 정상 접근 허용
  if (studentStatus === 'active' || studentStatus === 'expiring-soon') {
    return <Outlet />;
  }

  // 상태별 안내 페이지 분기
  if (studentStatus === 'expired') {
    return <Navigate to="/access-denied?reason=expired" replace />;
  }

  if (studentStatus === 'inactive') {
    return <Navigate to="/access-denied?reason=inactive" replace />;
  }

  if (studentStatus === 'not-enrolled') {
    return <Navigate to="/access-denied?reason=not-enrolled" replace />;
  }

  // 그 외 알 수 없는 상태도 기본 차단
  return <Navigate to="/access-denied?reason=denied" replace />;
}

// ③ 관리자 전용
export function RequireAdmin() {
  const { user, isAdmin, authLoading } = useAuth();

  if (authLoading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;

  return <Outlet />;
}